export default [
  2880,
  1920,
  1600,
  1370,
  1025,
  770,
]